"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_plot_1 = require("react-plot");
function PlotChart({ data, sign, color, yLogBase, hideHeading = false, }) {
    return ((0, jsx_runtime_1.jsxs)(react_plot_1.Plot, { width: 180, height: 220, children: [!hideHeading && (0, jsx_runtime_1.jsx)(react_plot_1.Heading, { title: "Sanplot" }), (0, jsx_runtime_1.jsx)(react_plot_1.LineSeries, { data: data.sanPlot?.[sign] || [], xAxis: "x", yAxis: "y", label: sign, lineStyle: {
                    stroke: color,
                    strokeWidth: 1.2,
                }, markerStyle: {
                    fill: color,
                    stroke: color,
                } }), (0, jsx_runtime_1.jsx)(react_plot_1.LineSeries, { data: data.lines?.[sign] || [], xAxis: "x", yAxis: "y", label: "noise level", lineStyle: {
                    stroke: 'blue',
                    strokeWidth: 0.8,
                    strokeDasharray: '3, 3',
                }, markerStyle: {
                    fill: color,
                    stroke: color,
                } }), (0, jsx_runtime_1.jsx)(react_plot_1.Axis, { id: "x", label: "Pt", position: "bottom", tickLabelStyle: { fontSize: '0.6rem' }, labelStyle: { fontSize: '0.6rem' } }), (0, jsx_runtime_1.jsx)(react_plot_1.Axis, { id: "y", label: `Intensity [Log${yLogBase}]`, position: "left", tickLabelStyle: { fontSize: '0.6rem' }, labelStyle: { fontSize: '0.7rem' } }), (0, jsx_runtime_1.jsx)(react_plot_1.Legend, { position: "embedded", bottom: 5, right: 60 })] }));
}
exports.default = PlotChart;
